export default __webpack_public_path__ + "static/Dc-dRoA-0d3ebafdc90e827048104c2cc0c2cd05.jpeg";